import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
// client js begin
import VftQrcode from '@tencent/vft-ui/src/Qrcode/Qrcode.vue'; // 这个不支持服务端渲染，所以用了 \/\/ client js begin 打包的时候去除掉
// client js end

import mixin from '../mixin';
import util from '../../../util';
export default {
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    paramsObj: {
      type: Object,
      required: true
    }
  },
  computed: {
    isQrCodeTag: function isQrCodeTag() {
      // 客户端 并且是 非短链
      return !this.isSSR && this.item.isQrCode && !this.item.isShortUrl;
    },
    realText: function realText() {
      var text = util.replaceParams(this.item.text, this.paramsObj);
      return this.isSSR ? util.filterText(text) : text;
    },
    realSrc: function realSrc() {
      var src = util.replaceParams(this.item.src, this.paramsObj); // 二维码（ssr 和 短链的）走 pay域名

      return this.item.isQrCode && (this.isSSR || this.item.isShortUrl) ? "https://vip.video.qq.com/fcgi-bin/comm_cgi?name=short_url&url=".concat(encodeURIComponent(src)).concat(this.item.isShortUrl ? '&need_short_url=1' : '', "&need_qrcode=1") : src;
    },
    imgStyleObj: function imgStyleObj() {
      return {
        width: "".concat(this.item.width, "px"),
        height: "".concat(this.item.height, "px"),
        display: 'block'
      };
    },
    styleObj: function styleObj() {
      var base = {
        width: "".concat(this.item.width, "px"),
        height: "".concat(this.item.height, "px")
      };
      base.position = 'absolute';
      base.left = "".concat(this.item.x, "px");
      base.top = "".concat(this.item.y, "px");
      return Object.assign(base, util.getStyleObj(this.item.style) || {});
    },
    isSSR: function isSSR() {
      var vm = this;

      while (vm && vm.$options.name !== 'CloudSealCard') {
        vm = vm.$parent;
      }

      return vm ? vm.isSSR : false;
    }
  },
  methods: {
    getChildNode: function getChildNode() {
      var vm = this;
      var item = vm.item;
      return {
        style: vm.imgStyleObj,
        attrs: {
          'data-content-type': item.zip && item.zip > 0 ? 'image/jpeg' : '',
          'data-zip': item.zip && item.zip > 0 ? item.zip : '',
          src: vm.removeHttp(vm.realSrc)
        }
      };
    },
    getVNode: function getVNode() {
      var vm = this;
      var item = vm.item;
      var type = item.type;
      var obj = {
        class: [item.className],
        attrs: {
          id: item.id
        },
        style: vm.styleObj
      };

      if (type === 'text') {
        obj.domProps = {
          innerHTML: vm.realText
        };
      }

      return obj;
    }
  },

  /** *
     * 由temple模板改成vnode,结构参考：
     * <template>
         <div :id="item.id" :class="item.className" :style="styleObj" v-html-text="item.type === 'text'?realText:null">
             <template v-if="item.type === 'img'">
                 <VftQrcode :style="imgStyleObj" v-if="item.isQrCode && !item.isShortUrl"
                     :options="{correctLevel: 1}" :url="realSrc">
                 </VftQrcode>
                 <img :data-zip="item.zip && item.zip > 0 ? item.zip : ''"
                      :data-content-type="item.zip && item.zip > 0 ?'image/jpeg':''"
                      :style="imgStyleObj" v-else :src="(shortUrl?shortUrl:realSrc)|removeHttp"/>
             </template>
             <template v-else="" v-html="realText"></template>
         </div>
       </template>
     * @param h
     * @returns {VNode}
     */
  render: function render(h) {
    var item = this.item;
    return h('div', this.getVNode(), item.type === 'img' ? [this.isQrCodeTag ? h('VftQrcode', {
      style: this.imgStyleObj,
      props: {
        options: {
          correctLevel: 1
        },
        url: this.realSrc
      }
    }) : h('img', this.getChildNode())] : []);
  },
  components: {
    // client js begin
    VftQrcode: VftQrcode // client js end

  }
};